import { TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { DamsColors } from "../styles/DamsColors"
import { TableCheckBox } from "./TablecheckBox";


function DamsTableHead({
    TColumns,
    maxHeaderItems,
    hasCheckBox,
    hasHeaderCheckBox=true,
    selectTableItems,
    allItemsSelected,
    hasItemsSelected }:
    Readonly<{
        TColumns?: string[],
        maxHeaderItems?: number,
        selectTableItems?: () => void,
        allItemsSelected: boolean,
        hasCheckBox?: boolean
        hasHeaderCheckBox?:boolean
        hasItemsSelected: boolean
    }>) {
    const columns = TColumns ?? ["Head 1", "Head 2", "Head 3", "Head 4", "Head 5", "Head 6", "Head 7", "Head 8", "Head 9", "Head 10"];

    return (
        <TableHead>
            <TableRow >
                {hasCheckBox && (
                    <TableCell
                        padding="checkbox"
                        sx={styles.tableHeaderColor}
                        align="center"
                    >{hasHeaderCheckBox && <TableCheckBox isHeader hasItemsSelected={hasItemsSelected} isChecked={allItemsSelected} onClick={selectTableItems}/>}

                    </TableCell>
                )}

                {columns.map((column, index) => (
                    maxHeaderItems && index >= maxHeaderItems
                        ? null
                        : (
                            <TableCell
                                sx={styles.tableHeaderColor}
                                key={index}>
                                <Typography
                                    fontFamily={'Inter'}
                                    color={DamsColors.Text.LabelTextLight}
                                    fontWeight={500}
                                    fontSize={12}
                                >
                                    {column}
                                </Typography>
                            </TableCell>
                        )
                ))}

                <TableCell sx={styles.tableHeaderColor} />

            </TableRow>
        </TableHead>
    );
}





const styles = {
    tableHeaderColor: {
        backgroundColor: DamsColors.Background.TableHeader
    },



}

export { DamsTableHead }
